<div
  class="paginator flex flex-col gap-3 md:flex-row md:gap-5 justify-end items-center"
>
  <!-- Page size selector -->
  <div class="page-size-selector flex items-center gap-3">
    <span class="text-sm">Items per page:</span>
    <single-select-input
      [options]="pageSizeOptions"
      [value]="limit"
      (valueChange)="onPageSizeChange($event)"
      class="border-1 border-solid border-neptune-subtle rounded-md"
    >
    </single-select-input>
  </div>

  <!-- Range label -->
  <div class="paginator-range text-sm">
    {{ rangeStart }}-{{ rangeEnd }} of {{ totalItems }}
  </div>

  <!-- Navigation buttons -->
  <div class="paginator-buttons flex gap-1">
    <div class="relative group">
      <button
        (click)="goToFirstPage()"
        [disabled]="currentPage === 1"
        class="bg-transparent px-2 py-3"
        aria-label="First page"
      >
        <img
          src="../../../../assets/paginator/neptune_paginator_first_page.svg"
          alt="First page"
        />
      </button>

      <!-- Tooltip -->
      <div class="paginator-tooltip">First page</div>
    </div>

    <div class="relative group">
      <button
        (click)="goToPreviousPage()"
        [disabled]="currentPage === 1"
        class="bg-transparent px-2 py-3"
        aria-label="Previous page"
      >
        <img
          src="../../../../assets/paginator/neptune_paginator_previous_page.svg"
          alt="Previous page"
        />
      </button>

      <div class="paginator-tooltip">Previous page</div>
    </div>

    <div class="relative group">
      <button
        (click)="goToNextPage()"
        [disabled]="rangeEnd === totalItems"
        class="bg-transparent px-2 py-3"
        aria-label="Next page"
      >
        <img
          src="../../../../assets/paginator/neptune_paginator_next_page.svg"
          alt="Next page"
        />
      </button>

      <div class="paginator-tooltip">Next page</div>
    </div>

    <div class="relative group">
      <button
        (click)="goToLastPage()"
        [disabled]="rangeEnd === totalItems"
        class="bg-transparent px-2 py-3"
        aria-label="Last page"
      >
        <img
          src="../../../../assets/paginator/neptune_paginator_last_page.svg"
          alt="Last page"
        />
      </button>

      <div class="paginator-tooltip">Last page</div>
    </div>
  </div>
</div>
